import React from 'react';
import { CommonLabel } from '@/components/ui/common-label';
import { cn } from '@/lib/utils';

const ThemedChartCard = ({ 
  title, 
  children, 
  className,
  ...props 
}) => {
  return (
    <div
      className={cn(
        "w-full bg-card border border-border rounded-[16px] box-border font-sans transition-all duration-200",
        "shadow-[0px_4.9px_19.6px_0px_hsl(var(--border)_/_0.12)]",
        className
      )}
      {...props}
    >
      <div className="flex justify-between px-3 pt-3">
        <CommonLabel size="sm" weight="semibold" className="text-foreground">
          {title}
        </CommonLabel>
      </div>
      <div className="p-3">
        {children}
      </div>
    </div>
  );
};

export default ThemedChartCard;